import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/Dashbord-service/dashbord.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Chart } from 'chart.js/auto';
import { FormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, LoadingSpinnerComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('myChartCanvas') myChartCanvas!: any;

  COOCount: number = 0;
  totals: Total[] = [];
  activityLogs!: ActiveData[];
  chart: any;
  activeButton: string = 'week';

  isLoading: boolean = false;


  constructor(
    private dashboardService: DashboardService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.fetchOfficerCounts();
    this.fetchChart('week')
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fetchChart('week');  // safe: canvas is ready
    }, 0);
  }

  fetchOfficerCounts(): void {
    this.isLoading = true;
    this.dashboardService.getOfficerCounts().subscribe(
      (data) => {
        this.COOCount = data.COOCount.COOCOUNT;
        this.activityLogs = data.activities;
        this.isLoading = false;

      },
      (error) => {
        this.isLoading = false;
        console.error('Error fetching officer counts', error);
      }
    );
  }

  formatDate(dateString: string, format: string = 'h:mm a'): string {
    const formattedDate = this.datePipe.transform(dateString, format);
    return formattedDate ? formattedDate : 'Unknown time';
  }


  fetchChart(filter: string) {
    this.activeButton = filter;
    this.isLoading = true;
    this.dashboardService.getChartData(filter).subscribe(
      (response: any) => {

        this.isLoading = false;

        this.totals = response;


        const labels = this.totals.map(item => item.date);
        const data = this.totals.map(item => item.totCount);


        const canvas = this.myChartCanvas.nativeElement;


        if (canvas) {

          if (this.chart) {
            this.chart.destroy();
          }

          this.chart = new Chart(canvas, {
            type: 'line',
            data: {
              labels: labels,
              datasets: [
                {
                  label: "",
                  data: data,
                  borderColor: "#4E97FD",
                  backgroundColor: "#6F64A766",
                  fill: true,
                  tension: 0.4,

                },
              ]
            },
            options: {
              responsive: true,
              plugins: {
                legend: {
                  display: true,
                  labels: {
                    color: ''
                  }
                }
              },
              scales: {
                x: {
                  ticks: {
                    color: 'black'
                  },
                  grid: {
                    display: true,
                    color: '#060606',

                  }
                },
                y: {
                  ticks: {
                    color: 'black'
                  },
                  grid: {
                    display: true,
                    color: '#060606'
                  }
                }
              }
            }
          });
        } else {
          console.error('Canvas element not found');
          this.isLoading = false
        }
      },
      (error) => {
        this.isLoading = false
        console.error('Error fetching chart data:', error);
      }
    );

    // this.isLoading = false;
  }



  updateChart() {
    if (this.chart) {
      this.isLoading = true
      this.chart.data.labels = this.totals.map((item) => item.date);
      this.chart.data.datasets[0].data = this.totals.map((item) => item.totCount);
      this.chart.update();
      this.isLoading = false;
    }
  }
}

class ActiveData {
  cropNameEnglish!: string;
  grade!: string;
  price!: string;
  updatedPrice!: string;
  varietyNameEnglish!: string;
  updateAt!: string;
}

class Total {
  date!: string;
  totCount!: number;
}
